import { useQuery, useQueryClient } from "@tanstack/react-query"
import BaseModal from "../../../components/layout/BaseModal"
import { Customer, CustomerType } from "../types/Types"
import { useContext, useState } from "react"
import { ModalContext } from "../../../components/contexts/ModalContext"
import { useDeleteAdministratorMutation } from "../api/services"
import { preventKeyDown } from "../../../services/functions"
import AddCustomerModalScreen1 from "./addCustomerModal/AddCustomerModalScreen1"
import { getAllAdministrator } from "../api/apiCalls"
import ErrorPage from "../../404/ErrorPage"
import Loading from "../../../components/common/Loading"
import { usePostDataMutation } from "../../api/services"
import { Form, FormInstance } from "antd"
import { GeneralQueryKeys } from "../../../api/constants"

type AddCustomerModalType = {
    queryKey: string
}

export default function AddCustomerModal(props: AddCustomerModalType) {
    const { data, error, isLoading } = useQuery({
        queryKey: [GeneralQueryKeys.ADMINISTRATOR_ALL],
        queryFn: getAllAdministrator,
    })
    const [customer, setCustomer] = useState<CustomerType>()
    const [administrator, setAdministrator] = useState<CustomerType>()

    const [screen2, setscreen2] = useState(false)
    const [inputAdmin, setinputAdmin] = useState(false)
    const [choosenAdmin, setchoosenAdmin] = useState()

    const queryClient = useQueryClient()
    const modalCon = useContext(ModalContext)

    // clears input after adding a new customer
    const clearInput = () => {
        setscreen2(false)
        setCustomer(undefined)
        setAdministrator(undefined)
        form1.resetFields()
        form2.resetFields()
    }

    // ADD Functions
    const { mutate: addCustomer } = usePostDataMutation(queryClient, "Kunde", props.queryKey)
    const handleNewCustomer = () => {
        const newCustomerData: Customer = {
            customer: customer as CustomerType,
            administrator: administrator as CustomerType,
        }
        if (choosenAdmin) {
            newCustomerData.administrator = data.filter((item: any) => item._id === choosenAdmin)[0]
        }
        modalCon?.trigger(1)
        addCustomer({ body: newCustomerData, pageType: "customer" })
        clearInput()
    }

    // delete Administrator
    const [deleteAdminScreen, setdeleteAdminScreen] = useState<boolean>(false)
    const { mutate: deleteAdministratorFunction } = useDeleteAdministratorMutation(queryClient, setdeleteAdminScreen, () =>
        setchoosenAdmin(undefined)
    )
    const deleteAdministrator = () => {
        console.log(choosenAdmin)
        deleteAdministratorFunction(choosenAdmin ?? "")
    }

    // FRONTEND LOGIC
    const [form1] = Form.useForm()
    const [form2] = Form.useForm()
    const handleNextModalScreen = async (func: () => void, form?: FormInstance) => {
        try {
            if (form) await form.validateFields()
            func()
            form?.resetFields()
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <>
            {error && <ErrorPage />}
            {isLoading && <Loading />}
            {data && !error && !isLoading && (
                <BaseModal
                    onClose={clearInput}
                    title={"Kunden hinzufügen - " + (screen2 ? "Verwaltung" : "Besitzer")}
                    modalId={1}
                    bottomRow={
                        <div className="flex justify-between">
                            <button
                                onKeyDown={() => preventKeyDown}
                                disabled={!screen2}
                                className="underline text-sm"
                                onClick={() => setscreen2(false)}>
                                zurück
                            </button>
                            {!screen2 ? (
                                <button
                                    onKeyDown={() => preventKeyDown}
                                    className="btn btn-primary btn-outline"
                                    onClick={() => handleNextModalScreen(() => setscreen2(true), form1)}>
                                    Weiter
                                </button>
                            ) : (
                                <button
                                    onClick={() => handleNextModalScreen(handleNewCustomer, form2)}
                                    className="btn btn-primary"
                                    // disabled={choosenAdmin === "" || choosenAdmin === "Bitte Auswählen"}
                                    >
                                    Speichern
                                </button>
                            )}
                        </div>
                    }>
                    {!screen2 ? (
                        <AddCustomerModalScreen1 form={form1} customer={customer as CustomerType} setCustomer={setCustomer} inputType="customer" />
                    ) : (
                        <AddCustomerModalScreen1
                            form={form2}
                            customer={administrator as CustomerType}
                            setCustomer={setAdministrator}
                            adminList={data}
                            choosenAdmin={choosenAdmin}
                            setchoosenAdmin={setchoosenAdmin}
                            inputAdmin={inputAdmin}
                            setinputAdmin={() => setinputAdmin(!inputAdmin)}
                            deleteAdmin={deleteAdministrator}
                            deleteAdminScreen={deleteAdminScreen}
                            setdeleteAdminScreen={() => setdeleteAdminScreen(!deleteAdminScreen)}
                            inputType="administrator"
                        />
                    )}
                </BaseModal>
            )}
        </>
    )
}
